import * as THREE from "three";
import { bumpMap } from "three/examples/jsm/nodes/display/BumpMapNode.js";

  const roughness = 0.25;
  const metalness = 1.0;

  const porcEnvMapIntesity = 0.95;
  const porcColor = 0x999999;
  const porcMetalness = 0.75;
  const porcRoughness = 0.7;
  const porcBumpScale = 0.01;
  const bussardInnerMaterialEmissiveIntensity = 0.5;
  const texSaucerEmIntensity = 0.9

  const cubeLoader = new THREE.CubeTextureLoader();
  cubeLoader.setPath("./images/cubemap/");

  const skyboxTexture = cubeLoader.load
  ([
    "right.jpg", // +X (right)
    "left.jpg", // -X (left)
    "top.jpg", // +Y (top)
    "bottom.jpg", // -Y (bottom)
    "front.jpg", // +Z (front)
    "back.jpg",  // -Z (back)
  ]);

  const nacelleDefaultRotation = Math.PI * 0.0;
  const texturePorcEqui = new THREE.TextureLoader().load( './images/matcap_chrome.jpg' );
  texturePorcEqui.mapping = THREE.EquirectangularReflectionMapping;
  texturePorcEqui.colorSpace = THREE.SRGBColorSpace;

  var texNacellePorc = new THREE.TextureLoader().load( "./images/nacelle_porc2.png");
  texNacellePorc.wrapS = THREE.MirroredRepeatWrapping;
  texNacellePorc.wrapT = THREE.MirroredRepeatWrapping;
  texNacellePorc.repeat.set( 2, 1 );
  texNacellePorc.rotation = nacelleDefaultRotation;
  texNacellePorc.colorSpace = THREE.SRGBColorSpace;

  var texBussardRearPorc = new THREE.TextureLoader().load( "./images/bussard_rear_porc.png");
  texBussardRearPorc.wrapS = THREE.MirroredRepeatWrapping;
  texBussardRearPorc.wrapT = THREE.MirroredRepeatWrapping;
  texBussardRearPorc.repeat.set( 6, 2 );
  texBussardRearPorc.offset.set( 0, 0.0 );
  texBussardRearPorc.rotation = nacelleDefaultRotation;
  texBussardRearPorc.colorSpace = THREE.SRGBColorSpace;

  var texPorc = new THREE.TextureLoader().load( "./images/nacelle_porc.jpg");
  texPorc.wrapS = THREE.MirroredRepeatWrapping;
  texPorc.wrapT = THREE.MirroredRepeatWrapping;
  texPorc.repeat.set( 0.5, 1 );
  texPorc.rotation = nacelleDefaultRotation;
  texPorc.colorSpace = THREE.SRGBColorSpace;

  var texNacelle = new THREE.TextureLoader().load( "./images/nacelle.png");
  texNacelle.wrapS = THREE.MirroredRepeatWrapping;
  texNacelle.wrapT = THREE.MirroredRepeatWrapping;
  texNacelle.repeat.set( 2, 1 );
  texNacelle.rotation = nacelleDefaultRotation;
  texNacelle.offset.set(0.0, 0.0); // Set rotation center to the middle of the texture

  var texNacelleEm = new THREE.TextureLoader().load( "./images/nacelle_em3.png");
  texNacelleEm.wrapS = THREE.MirroredRepeatWrapping;
  texNacelleEm.wrapT = THREE.MirroredRepeatWrapping;
  texNacelleEm.repeat.set( 2, 1 );
  texNacelleEm.rotation = nacelleDefaultRotation;
  texNacelleEm.colorSpace = THREE.SRGBColorSpace;

  var texNacelleSp = new THREE.TextureLoader().load( "./images/nacelle_sp.png");
  texNacelleSp.wrapS = THREE.MirroredRepeatWrapping;
  texNacelleSp.wrapT = THREE.MirroredRepeatWrapping;
  texNacelleSp.repeat.set( 6, 1 );
  texNacelleSp.rotation = nacelleDefaultRotation;
  
  var texNacellePorcEm = new THREE.TextureLoader().load( "./images/nacelle_porc_emmissive.jpg");
  texNacellePorcEm.wrapS = THREE.MirroredRepeatWrapping;
  texNacellePorcEm.wrapT = THREE.MirroredRepeatWrapping;
  texNacellePorcEm.repeat.set( 2, 1 );
  texNacellePorcEm.rotation =  Math.PI * 1.0;
  const rotation = - Math.PI * 1.0;

  var texPylon = new THREE.TextureLoader().load( "./images/pylon.png");
  texPylon.wrapS = THREE.MirroredRepeatWrapping;
  texPylon.wrapT = THREE.MirroredRepeatWrapping;
  texPylon.rotation = rotation;
  texPylon.repeat.set( -0.9, 0.8);
  texPylon.offset.set( -1, -1);

  var texPylonSp = new THREE.TextureLoader().load( "./images/pylon_sp.png");
  texPylonSp.wrapS = THREE.MirroredRepeatWrapping;
  texPylonSp.wrapT = THREE.MirroredRepeatWrapping;
  texPylonSp.rotation = rotation;
  texPylonSp.repeat.set( 1.0, 0.5);

  var texPylonEm = new THREE.TextureLoader().load( "./images/pylonEm2.png");
  texPylonEm.wrapS = THREE.MirroredRepeatWrapping;
  texPylonEm.wrapT = THREE.MirroredRepeatWrapping;
  texPylonEm.rotation = rotation;
  texPylonEm.repeat.set(1, 1);
  texPylonEm.offset.set(0.0, 0.0);
  texPylonEm.colorSpace = THREE.SRGBColorSpace

  var texPylonSp_03 = new THREE.TextureLoader().load( "./images/pylonEm2.png");
  texPylonSp_03.wrapS = THREE.MirroredRepeatWrapping;
  texPylonSp_03.wrapT = THREE.MirroredRepeatWrapping;
  texPylonSp_03.rotation = rotation;
  texPylonSp_03.repeat.set(2, 2);
  texPylonSp_03.offset.set(0.0, 0.0);
  texPylonSp_03.colorSpace = THREE.SRGBColorSpace

  var texNeck = new THREE.TextureLoader().load( "./images/engineering.png");
  texNeck.wrapS = THREE.MirroredRepeatWrapping;
  texNeck.wrapT = THREE.MirroredRepeatWrapping;
  texNeck.repeat.set( 2, 2 );

  var texNeckEm = new THREE.TextureLoader().load( "./images/neck_em.png");
  texNeckEm.wrapS = THREE.MirroredRepeatWrapping;
  texNeckEm.wrapT = THREE.RepeatWrapping;
  texNeckEm.repeat.set( 2, 3.0 );
  texNeckEm.offset.set( 0.00, 0.35);
  texNeckEm.colorSpace = THREE.SRGBColorSpace;

  var texNeckSp = new THREE.TextureLoader().load( "./images/engineering_sp.png");
  texNeckSp.wrapS = THREE.MirroredRepeatWrapping;
  texNeckSp.wrapT = THREE.MirroredRepeatWrapping;
  texNeckSp.repeat.set( -0.0, 0.0 );
  var texNeckNm = new THREE.TextureLoader().load( "./images/neck2_nm.png");

  var texNotch = new THREE.TextureLoader().load( "./images/saucer.png");
  texNotch.wrapS = THREE.RepeatWrapping;
  texNotch.wrapT = THREE.RepeatWrapping;
  texNotch.repeat.set( 0.25,0.5 );
  texNotch.colorSpace = THREE.SRGBColorSpace;

  var texNotchEm = new THREE.TextureLoader().load( "./images/saucer_em.png");
  texNotchEm.wrapS = THREE.RepeatWrapping;
  texNotchEm.wrapT = THREE.RepeatWrapping;
  texNotchEm.repeat.set( 0.25,0.5 );
  texNotchEm.colorSpace = THREE.SRGBColorSpace;

  var texNotchSp = new THREE.TextureLoader().load( "./images/saucer_sp.png");
  texNotchSp.wrapS = THREE.RepeatWrapping;
  texNotchSp.wrapT = THREE.RepeatWrapping;
  texNotchSp.repeat.set( 0.1,0.5 );
  texNotchSp.colorSpace = THREE.SRGBColorSpace;

  var texBridge = new THREE.TextureLoader().load( "./images/saucer.png");
  texBridge.wrapS = THREE.MirroredRepeatWrapping;
  texBridge.wrapT = THREE.MirroredRepeatWrapping;
  texBridge.repeat.set( 8, 8 );
  texBridge.colorSpace = THREE.SRGBColorSpace;

  var texBridgeEm = new THREE.TextureLoader().load( "./images/bridge_em.png");
  texBridgeEm.wrapS = THREE.MirroredRepeatWrapping;
  texBridgeEm.wrapT = THREE.MirroredRepeatWrapping;
  texBridgeEm.repeat.set( 2, 4 );
  texBridgeEm.offset.x = 1;
  texBridgeEm.colorSpace = THREE.SRGBColorSpace;

  var texBridgeSp = new THREE.TextureLoader().load( "./images/saucer_sp.png");
  texBridgeSp.wrapS = THREE.MirroredRepeatWrapping;
  texBridgeSp.wrapT = THREE.MirroredRepeatWrapping;
  texBridgeSp.repeat.set( 8, 8 );
  texBridgeSp.colorSpace = THREE.SRGBColorSpace;

  const texSaucer = new THREE.TextureLoader().load( "./images/saucer.png");
  texSaucer.wrapS = THREE.MirroredRepeatWrapping;
  texSaucer.wrapT = THREE.MirroredRepeatWrapping;
  texSaucer.repeat.set( 2, 6 );
  texSaucer.colorSpace = THREE.SRGBColorSpace;

  const texSaucerEm = new THREE.TextureLoader().load( "./images/saucer_em.png");
  texSaucerEm.wrapS = THREE.MirroredRepeatWrapping;
  texSaucerEm.wrapT = THREE.MirroredRepeatWrapping;
  texSaucerEm.repeat.set( 6, 2.2 );
  texSaucerEm.offset.set( 0.0, 0.2);
  texSaucerEm.colorSpace = THREE.SRGBColorSpace;

  const texSaucerInvertEm = new THREE.TextureLoader().load( "./images/saucer_invert_em.jpg");
  texSaucerInvertEm.wrapS = THREE.MirroredRepeatWrapping;
  texSaucerInvertEm.wrapT = THREE.MirroredRepeatWrapping;
  texSaucerInvertEm.repeat.set( 6,6 );
  texSaucerInvertEm.colorSpace = THREE.SRGBColorSpace;

  const texSaucerSp = new THREE.TextureLoader().load( "./images/saucer_sp.png");
  texSaucerSp.wrapS = THREE.MirroredRepeatWrapping;
  texSaucerSp.wrapT = THREE.MirroredRepeatWrapping;
  texSaucerSp.repeat.set( 3, 2 );
  texSaucerSp.colorSpace = THREE.SRGBColorSpace;

  const texBussard = new THREE.TextureLoader().load( "./images/bussard_em.png");
  texBussard.wrapS = THREE.RepeatWrapping;
  texBussard.wrapT = THREE.RepeatWrapping;
  texBussard.repeat.set( 9, 1.5 );
  texBussard.colorSpace = THREE.SRGBColorSpace;

  var texGrill = new THREE.TextureLoader().load( "./images/grill.png");
  texGrill.wrapS = THREE.RepeatWrapping;
  texGrill.wrapT = THREE.RepeatWrapping;
  texGrill.repeat.set( 9, 1.3);
  texGrill.colorSpace = THREE.SRGBColorSpace;

  var texEng = new THREE.TextureLoader().load( "./images/engineering.png");
  texEng.wrapS = THREE.MirroredRepeatWrapping;
  texEng.wrapT = THREE.MirroredRepeatWrapping;
  texEng.repeat.set( 2, 1 );

  var texEngSp = new THREE.TextureLoader().load( "./images/engineering_sp.png");
  texEngSp.wrapS = THREE.MirroredRepeatWrapping;
  texEngSp.wrapT = THREE.MirroredRepeatWrapping;
  texEngSp.repeat.set( 4, 4 );

  var texEngPorc = new THREE.TextureLoader().load( "./images/eng_porcelain.jpg");
  texEngPorc.wrapS = THREE.MirroredRepeatWrapping;
  texEngPorc.wrapT = THREE.RepeatWrapping;
  texEngPorc.repeat.set( 2, 1.0 );
  texEngPorc.offset.set(0.0, 0.0);

  var texEngEm = new THREE.TextureLoader().load( "./images/engineering_em.png");
  texEngEm.wrapS = THREE.MirroredRepeatWrapping;
  texEngEm.wrapT = THREE.MirroredRepeatWrapping;
  texEngEm.repeat.set( 4, 2);
  texEngEm.rotation = Math.PI * 1.0;
  texEngEm.offset.set(0.0, 0.01);
  texEngEm.colorSpace = THREE.SRGBColorSpace;

  const texDesk = new THREE.TextureLoader().load( "./images/saucer.png");
  texDesk.wrapS = THREE.MirroredRepeatWrapping;
  texDesk.wrapT = THREE.MirroredRepeatWrapping;
  texDesk.repeat.set( 1, 2 );

  const tex1963 = new THREE.TextureLoader().load( "./images/saucer2.jpg");
  tex1963.wrapS = THREE.MirroredRepeatWrapping;
  tex1963.wrapT = THREE.MirroredRepeatWrapping;
  tex1963.repeat.set( 3, 6 );
  tex1963.colorSpace = THREE.SRGBColorSpace;

  const texPorcBridge = new THREE.TextureLoader().load( "./images/saucer2.jpg");
  texPorcBridge.wrapS = THREE.MirroredRepeatWrapping;
  texPorcBridge.wrapT = THREE.MirroredRepeatWrapping;
  texPorcBridge.repeat.set( 6, 12 );
  texPorcBridge.colorSpace = THREE.SRGBColorSpace;

  var texDishSp = new THREE.TextureLoader().load( "./images/dish_sp.png");
  texDishSp.wrapS = THREE.MirroredRepeatWrapping;
  texDishSp.wrapT = THREE.MirroredRepeatWrapping;
  texDishSp.repeat.set( 12, 2 );

  var texDishTng = new THREE.TextureLoader().load( "./images/dish-tgn_em.png");
  texDishTng.wrapS = THREE.MirroredRepeatWrapping;
  texDishTng.wrapT = THREE.MirroredRepeatWrapping;
  texDishTng.repeat.set( 1.0, 1.0 );
  texDishTng.offset.set(0.0, 0.0);

  var texDishTmp = new THREE.TextureLoader().load( "./images/dish-tgn.jpg");
  texDishTmp.wrapS = THREE.RepeatWrapping;
  texDishTmp.wrapT = THREE.MirroredRepeatWrapping;
  texDishTmp.repeat.set( 9.0, 1.0 );
  texDishTmp.offset.set(0.0, 0.0);

  var texDishEm = new THREE.TextureLoader().load( "./images/dish_sp.png");
  texDishEm.wrapS = THREE.MirroredRepeatWrapping;
  texDishEm.wrapT = THREE.MirroredRepeatWrapping;
  texDishEm.repeat.set( 24, 4 );
  texDishEm.colorSpace = THREE.SRGBColorSpace;

  var texDish = new THREE.TextureLoader().load( "./images/dish.png");
  texDish.wrapS = THREE.MirroredRepeatWrapping;
  texDish.wrapT = THREE.MirroredRepeatWrapping;
  texDish.repeat.set( 6, 2 );

  const goldMaterial = new THREE.MeshMatcapMaterial( {
    color: 0xffffff,
    emissive: 0x99aaff,
    side: THREE.DoubleSide,
    matcap: new THREE.TextureLoader().load( "./images/matcap_gold.jpeg"),
    map: texDesk,
  } );

  const goldDishMaterial = new THREE.MeshStandardMaterial({
    color: 0xffaa22,
    emissive: 0xff9922,
    side: THREE.DoubleSide,
    envMap: texturePorcEqui,
    envMapIntensity: 3.0,
    emissiveMap: texBridgeEm,
    emissiveIntensity: 5,
    roughness: 0.7,
    roughnessMap: texturePorcEqui,
    metallessMap: texDish,
    metalness: 1.0,
    map: texDish,
    bumpMap: texDishEm,
    bumpScale: 0,
} );

  const porcMaterial = new THREE.MeshStandardMaterial( {
    color: porcColor,
    emissive: 0xffffff,
    side: THREE.DoubleSide,
    map: texPorc,
    envMap: texturePorcEqui,
    envMapIntensity: porcEnvMapIntesity,
    emissiveMap: texEngEm, 
    emissiveIntensity: 0.0,
    roughnessMap: texNacelleSp,
    roughness: porcRoughness * 2.5,
    metalness: porcMetalness * 0.5,
    bumpMap: texPorc,
    bumpScale: porcBumpScale,
  } );

  const porcNeckMaterial = new THREE.MeshStandardMaterial( {
    color: porcColor,
    emissive: 0xffffff,
    side: THREE.DoubleSide,
    map: texPorc,
    envMap: texturePorcEqui,
    envMapIntensity: porcEnvMapIntesity,
    emissiveMap: texNeckEm, 
    emissiveIntensity: 1.0,
    roughnessMap: texNacelleSp,
    roughness: porcRoughness * 2.5,
    metalness: porcMetalness * 0.1,
    bumpMap: texPorc,
    bumpScale: porcBumpScale,
  } );

  const porcNacelleMaterial = new THREE.MeshStandardMaterial( {
    color: porcColor,
    emissive: 0xaaddff,
    side: THREE.DoubleSide,
    map: texNacellePorc,
    envMap: texturePorcEqui,
    envMapIntensity: porcEnvMapIntesity,
    emissiveMap: texNacelleEm,
    emissiveIntensity: 1.2,
    metalnessMap: texNacelleSp,
    roughness: porcRoughness,
    metalness: porcMetalness,
    bumpMap: texNacelleSp,
    bumpScale: porcBumpScale * 0.3,
  } );

  const porcBussardRearMaterial = new THREE.MeshStandardMaterial( {
    color: porcColor,
    emissive: 0xaaddff,
    side: THREE.DoubleSide,
    map: texBussardRearPorc,
    envMap: texturePorcEqui,
    envMapIntensity: porcEnvMapIntesity,
    emissiveIntensity:0,
    metalnessMap: texBussardRearPorc,
    roughness: porcRoughness/2,
    metalness: porcMetalness,
    bumpMap: texBussardRearPorc,
    bumpScale: porcBumpScale * 0.3,
  } );

  const porcEngMaterial = new THREE.MeshStandardMaterial( {
    color: porcColor,
    emissive: 0xffffff,
    side: THREE.DoubleSide,
    // matcap: new THREE.TextureLoader().load( "./images/matcap-porcelain-white.jpg"),
    map: texEngPorc,
    envMap: texturePorcEqui,
    envMapIntensity: porcEnvMapIntesity,
    emissiveMap: texEngEm,
    emissiveIntensity: 0.9,
    roughnessMap: texEngPorc,
    roughness: porcRoughness * 0.9,
    metalness: porcMetalness * 1.2,
    // normalMap: texPylonEm,
    // normalScale: new THREE.Vector2( 2, 2 ),
    bumpMap: texEng,
    bumpScale: porcBumpScale * -1.0,
  } );

  const porcSaucerMaterial = new THREE.MeshStandardMaterial({
      color: porcColor,
      castShadow: true,
      emissive: 0xffffff,
      side: THREE.DoubleSide,
      // matcap: new THREE.TextureLoader().load( "./images/matcap-porcelain-white.jpg"),
      envMap: texturePorcEqui,
      envMapIntensity: porcEnvMapIntesity,
      emissiveMap: texSaucerEm,
      emissiveIntensity: texSaucerEmIntensity,
      roughness: porcRoughness,
      metalness: porcMetalness,
      roughnessMap: texSaucer,
      map: tex1963,
      bumpMap: texSaucer,
      bumpScale: porcBumpScale,
  } );

  const wireframeMaterial = new THREE.MeshStandardMaterial( {
    color: 0xffffff,
    emissive: 0xffffff,
    emissiveIntensity: 0.1,
    side: THREE.FrontSide,
    // transparent: true,
    // opacity: 0.3,
    wireframe: true,
    envMap: texturePorcEqui,
    envMapIntensity: 1.0,
  } );

  const chromeMaterial = new THREE.MeshMatcapMaterial( {
    color: 0xffffff,
    emissive: 0x99aaff,
    side: THREE.DoubleSide,
    matcap: new THREE.TextureLoader().load( "./images/matcap_chrome.jpg"),
    map: texDesk,
  } );

  export const hullMaterial = [];
  const hullMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xeeeeff,
    emissive: 0xeeeeff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    map: texSaucer,
    emissiveMap: texSaucerEm,
    emissiveIntensity: texSaucerEmIntensity,
    metalnessMap: texSaucerSp,
    metalness: 1.9,
    bumpMap: texSaucer,
    bumpScale: 0.01,
    roughness: roughness,
  });
  const hullMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xffffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texSaucerEm,
    emissiveIntensity: texSaucerEmIntensity,
    bumpMap: texSaucer,
    bumpScale: 0.01,
    metalnessMap: texSaucer,
    metalness: 0.7,
    roughness: 0.6,
    roughnessMap: texSaucer,
  });
  const hullMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x222222,
    emissive: 0xaaffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texSaucerEm,
    emissiveIntensity: texSaucerEmIntensity,
    metalnessMap: texSaucer,
    metalness: 1.0,
    roughness: 0.6,
  });
  hullMaterial.push(hullMaterial_01);
  hullMaterial.push(hullMaterial_02);
  hullMaterial.push(hullMaterial_03);
  hullMaterial.push(goldMaterial);
  hullMaterial.push(chromeMaterial);
  hullMaterial.push(wireframeMaterial);
  hullMaterial.push(porcSaucerMaterial);

  export const bridgeMaterial = [];
  const porcBridgeMaterial = new THREE.MeshStandardMaterial({
    color: porcColor,
    emissive: 0xffffff,
    side: THREE.DoubleSide,
    envMap: texturePorcEqui,
    envMapIntensity: porcEnvMapIntesity,
    emissiveMap: texBridgeEm,
    emissiveIntensity: 2.0,
    roughness: porcRoughness,
    metalness: porcMetalness,
    roughnessMap: texSaucer,
    map: texPorcBridge,
    bumpMap: texBridge,
    bumpScale: porcBumpScale,
  } );
  const bridgeMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xeeeeff,
    emissive: 0xeeeeff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    map: texSaucer,
    emissiveMap: texBridgeEm,
    emissiveIntensity: 2.0,
    metalnessMap: texBridgeSp,
    metalness: 1.0,
    bumpMap: texBridge,
    bumpScale: 0.005,
    roughness: roughness,
  });
  const bridgeMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xffffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texBridgeEm,
    emissiveIntensity: 2.0,
    bumpMap: texBridge,
    bumpScale: 0.01,
    metalnessMap: texBridge,
    metalness: 0.6,
    roughness: 0.6,
  });
  const bridgeMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x222222,
    emissive: 0x00ffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texBridgeEm,
    emissiveIntensity: 2.0,
    metalnessMap: texBridge,
    metalness: 1,
    roughness: 0.6,
  });
  bridgeMaterial.push(bridgeMaterial_01);
  bridgeMaterial.push(bridgeMaterial_02);
  bridgeMaterial.push(bridgeMaterial_03);
  bridgeMaterial.push(goldMaterial);
  bridgeMaterial.push(chromeMaterial);
  bridgeMaterial.push(wireframeMaterial);
  bridgeMaterial.push(porcBridgeMaterial);

  export const notchMaterial = [];
  const notchMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xaaaaab,
    emissive: 0xeeeeff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    map: texNotch,
    emissiveMap: texNotchEm,
    emissiveIntensity: 1.0,
    // bumpMap: texNotch,
    // bumpScale: 0.001,
    metalnessMap: texNotchSp,
    metalness: 0.5,
    roughness: roughness,
  });
  const notchMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xffffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texNotchEm,
    emissiveIntensity: 1.0,
    // bumpMap: texNotch,
    // bumpScale: 0.001,
    metalnessMap: texNotchSp,
    metalness: 0.5,
    roughness: roughness,
  });
  const notchMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x222222,
    emissive: 0x00ffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texNotchEm,
    emissiveIntensity: 1.0,
    metalnessMap: texNotchSp,
    metalness: 1.0,
    roughness: roughness,
  });
  notchMaterial.push(notchMaterial_01);
  notchMaterial.push(notchMaterial_02);
  notchMaterial.push(notchMaterial_03);
  notchMaterial.push(goldMaterial);
  notchMaterial.push(chromeMaterial);
  notchMaterial.push(wireframeMaterial);
  notchMaterial.push(notchMaterial_01);

  

  export const engMaterial = [];
  const engMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xeeeeff,
    emissive: 0xffffff,
    emissiveMap: texEngEm,
    emissiveIntensity: 0.7,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    map: texEng,
    metalnessMap: texEngSp,
    metalness: 0.3,
    bumpMap: texEngSp,
    bumpScale: 0.005,
    roughness: roughness,
  });
  const engMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xffffff,
    emissiveMap: texEngEm,
    emissiveIntensity: 0.7,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    bumpMap: texEngSp,
    bumpScale: -0.002,
    metalnessMap: texEngSp,
    metalness: 0.3,
    roughness: roughness,
  });
  const engMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x222222,
    emissive: 0x00ffff,
    emissiveMap: texEngEm,
    emissiveIntensity: 0.7,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    metalnessMap: texEngSp,
    metalness: 1,
    roughness: roughness,
  });
  engMaterial.push(engMaterial_01);
  engMaterial.push(engMaterial_02);
  engMaterial.push(engMaterial_03);
  engMaterial.push(goldMaterial);
  engMaterial.push(chromeMaterial);
  engMaterial.push(wireframeMaterial);
  engMaterial.push(porcEngMaterial);

  export const neckMaterial = [];
  const neckMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xeeeeff,
    emissive: 0xffffff,
    emissiveMap: texNeckEm,
    emissiveIntensity: 1.0,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    map: texNeck,
    bumpMap: texNeck,
    bumpScale: 0.04,
    metalnessMap: texNeckSp,
    metalness: 0.4,
    roughness: roughness,
  });
  const neckMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xffffff,
    emissiveMap: texNeckEm,
    emissiveIntensity: 1.0,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    bumpMap: texNeck,
    bumpScale: 0.01,
    metalnessMap: texNeckSp,
    metalness: 0.3,
    roughness: roughness,
  });
  const neckMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x222222,
    emissive: 0x00ffff,
    emissiveMap: texNeckEm,
    emissiveIntensity: 1.0,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    metalnessMap: texNeckSp,
    metalness: 1,
    roughness: roughness,
  });
  neckMaterial.push(neckMaterial_01);
  neckMaterial.push(neckMaterial_02);
  neckMaterial.push(neckMaterial_03);
  neckMaterial.push(goldMaterial);
  neckMaterial.push(chromeMaterial);
  neckMaterial.push(wireframeMaterial);
  neckMaterial.push(porcNeckMaterial);
  
  

  export const pylonMaterial = [];
  const pylonMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xeeeeff,
    emissiveMap: texEngEm,
    emissiveIntensity: 0.0,
    side: THREE.DoubleSide,
    map: texPylon,
    metalnessMap: texPylon,
    metalness: 0.3,
    bumpMap: texPylon,
    bumpScale: -0.03,
    roughness: roughness,
  });
  const pylonMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissiveMap: texEngEm,
    emissiveIntensity: 0.0,
    side: THREE.DoubleSide,
    bumpMap: texPylonSp_03,
    bumpScale: 0.005,
    metalnessMap: texPylonSp_03,
    metalness: 0.5,
    roughness: roughness,
  });
  const pylonMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x222222,
    emissive: 0x00ffff,
    side: THREE.DoubleSide,
    metalnessMap: texPylonSp_03,
    metalness: 1.0,
    emissiveMap: texPylonEm,
    emissiveIntensity: 1,
    roughness: roughness,
  });
  pylonMaterial.push(pylonMaterial_01);
  pylonMaterial.push(pylonMaterial_02);
  pylonMaterial.push(pylonMaterial_03);
  pylonMaterial.push(goldMaterial);
  pylonMaterial.push(chromeMaterial);
  pylonMaterial.push(wireframeMaterial);
  pylonMaterial.push(porcMaterial);

  export const nacelleMaterial = [];
  const nacelleMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xeeeeff,
    emissive: 0xccccff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    map: texNacelle,
    emissiveMap: texNacelleEm,
    emissiveIntensity: 1.2,
    metalnessMap: texNacelleSp,
    metalness: 0.8,
    bumpMap: texNacelleSp,
    bumpScale: -0.03,
    roughness: roughness,
  });
  const nacelleMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xccffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texNacelleEm,
    emissiveIntensity: 0.8,
    bumpMap: texNacelleSp,
    bumpScale: -0.01,
    metalnessMap: texNacelleSp,
    metalness: 0.7,
    roughness: 0.6,
  });
  const nacelleMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x222222,
    emissive: 0x00ffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texNacelleEm,
    emissiveIntensity: 0.8,
    metalnessMap: texNacelleSp,
    metalness: 1,
    roughness: 0.6,
  });
  nacelleMaterial.push(nacelleMaterial_01);
  nacelleMaterial.push(nacelleMaterial_02);
  nacelleMaterial.push(nacelleMaterial_03);
  nacelleMaterial.push(goldMaterial);
  nacelleMaterial.push(chromeMaterial);
  nacelleMaterial.push(wireframeMaterial);
  nacelleMaterial.push(porcNacelleMaterial);


  export const bussardRearMaterial = [];
  const bussardRearMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xeeeeff,
    emissive: 0xccccff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    map: texNeck,
    emissiveMap: texNeckEm,
    emissiveIntensity: 0,
    metalnessMap: texNeckSp,
    metalness: 0.8,
    bumpMap: texNeckSp,
    bumpScale: -0.03,
    roughness: roughness,
  });
  const bussardRearMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xccffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texNeckEm,
    emissiveIntensity: 0.0,
    map: texBussardRearPorc,
    bumpMap: texBussardRearPorc,
    bumpScale: -0.03,
    metalnessMap: texBussardRearPorc,
    metalness: 0.7,
    roughness: 0.6,
  });
  const bussardRearMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x333333,
    emissive: 0x00ffff,
    side: THREE.DoubleSide,
    flatShading: false,
    wireframe: false,
    emissiveMap: texPylonEm,
    emissiveIntensity: 0.0,
    metalnessMap: texBussardRearPorc,
    metalness: 1.5,
    roughness: 0.6,
  });
  bussardRearMaterial.push(bussardRearMaterial_01);
  bussardRearMaterial.push(bussardRearMaterial_02);
  bussardRearMaterial.push(bussardRearMaterial_03);
  bussardRearMaterial.push(goldMaterial);
  bussardRearMaterial.push(chromeMaterial);
  bussardRearMaterial.push(wireframeMaterial);
  bussardRearMaterial.push(porcBussardRearMaterial);


  export const deflectorMaterial = [];
  const deflectorMaterial_01 = new THREE.MeshStandardMaterial( {
    color: 0x000000,
    map: texDishTng,
    emissive: 0x55aaff,
    emissiveMap: texDishTng,
    emissiveIntensity: 3,
    side: THREE.DoubleSide,
    roughness: 0.9,
    // bumpMap: texDishTng,
    // bumpScale: 0.1,
    metalness: 4,
    // metalnessMap: texDishTng,
    envMap: texturePorcEqui,
    envMapIntensity: 15.0,
    // alphaMap: texDishTng,
    // alphaTest: 0.5,
  } );

  const deflectorMaterial_02 = new THREE.MeshStandardMaterial( {
    color: 0x000000,
    emissive: 0x55aaff,
    emissiveMap: texDishTmp,
    emissiveIntensity: 2.5,
    // map: texDishEm,
    roughnessMap: texDishSp,
    envMap: texturePorcEqui,
    envMapIntensity: 15.0,
    side: THREE.DoubleSide,
    flatShading: false,
    metalness: 0.9,
    roughness: 0.9,
  } );

  const deflectorMaterial_03 = new THREE.MeshStandardMaterial( {
    color: 0x222222,
    emissive: 0x00ffff,
    emissiveMap: texDishEm,
    emissiveIntensity: 3.0,
    side: THREE.DoubleSide,
    flatShading: false,
    metalness: 0.9,
    roughness: 1.0,
  } );

  deflectorMaterial.push(deflectorMaterial_01);
  deflectorMaterial.push(deflectorMaterial_02);
  deflectorMaterial.push(deflectorMaterial_03);
  deflectorMaterial.push(goldMaterial);
  deflectorMaterial.push(chromeMaterial);
  deflectorMaterial.push(wireframeMaterial);
  deflectorMaterial.push(goldDishMaterial);

  export const bussardMaterial = [];
  const bussardMaterial_00 = new THREE.MeshStandardMaterial({
    color: 0xff0000,
    emissive: 0xff0000,
    emissiveIntensity: 3.0,
    opacity: 0.7,
    transparent: true,
    flatShading: false,
    side: THREE.DoubleSide,
    // emissiveMap: texDishEm,
    // metalnessMap: texBussard,
    // roughnessMap: texBussard,
    envMap: texturePorcEqui,
    envMapIntensity: 1,
    metalness: 0.1,
    roughness: 0.5,
  });
  
  const bussardMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xff0000,
    emissive: 0xff0000,
    emissiveIntensity: 3.0,
    opacity: 0.7,
    transparent: true,
    flatShading: false,
    side: THREE.DoubleSide,
    // emissiveMap: texDishEm,
    // metalnessMap: texBussard,
    // roughnessMap: texBussard,
    envMap: texturePorcEqui,
    envMapIntensity: 1,
    metalness: 0.1,
    roughness: 0.5,
  });

  const bussardMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0x00ffff,
    emissive: 0x99ddff,
    emissiveIntensity: 0.4,
    opacity: 0.6,
    transparent: true,
    flatShading: false,
    side: THREE.DoubleSide,
    metalnessMap: texBussard,
    roughnessMap: texBussard,
    envMap: texturePorcEqui,
    envMapIntensity: 5,
    metalness: 2,
    roughness: 0.5,
  });

  const bussardMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0x00ffff,
    emissive: 0x00eeff,
    emissiveIntensity: 0.8,
    opacity: 0.4,
    transparent: true,
    flatShading: false,
    side: THREE.DoubleSide,
    metalnessMap: texBussard,
    roughnessMap: texBussard,
    envMap: texturePorcEqui,
    envMapIntensity: 2,
    metalness: 2,
    roughness: 0.5,
  });

  bussardMaterial.push(bussardMaterial_00);
  bussardMaterial.push(bussardMaterial_01);
  bussardMaterial.push(bussardMaterial_02);
  bussardMaterial.push(goldMaterial);
  bussardMaterial.push(chromeMaterial);
  bussardMaterial.push(wireframeMaterial);
  bussardMaterial.push(bussardMaterial_01);
  
  export const bussardInnerMaterial = [];
  const bussardInnerMaterial_00 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xffffff,
    emissiveIntensity: bussardInnerMaterialEmissiveIntensity * 2.0,
    // transparent: true,
    flatShading: false,
    emissiveMap: texDishEm.clone(),
    map: texBussard,
    side: THREE.DoubleSide,
    // roughnessMap: texBussard,
    // envMap: texturePorcEqui,
    // envMapIntensity: 10,
    // metalness: 29,
    roughness: 0,
    alphaMap: texDishEm,
    alphaTest: 0.07,
  });
  const bussardInnerMaterial_01 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0x00ffff,
    emissiveIntensity: bussardInnerMaterialEmissiveIntensity,
    transparent: false,
    flatShading: false,
    emissiveMap: texBussard.clone(),
    // metalnessMap: texBussard,
    side: THREE.DoubleSide,
    roughnessMap: texBussard,
    metalness: 1,
    roughness: 0.1,
    alphaMap: texBussard,
    alphaTest: 0.1,
  });
  const bussardInnerMaterial_02 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xffffff,
    emissiveIntensity: bussardInnerMaterialEmissiveIntensity * 0.5,
    transparent: false,
    flatShading: false,
    emissiveMap: texBussard.clone(),
    metalnessMap: texBussard,
    side: THREE.DoubleSide,
    alphaMap: texBussard,
    alphaTest: 0.01,
    metalness: 0.6,
    roughness: 1.0,
  });
  const bussardInnerMaterial_03 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    emissive: 0xffffff,
    emissiveIntensity: bussardInnerMaterialEmissiveIntensity * 0.5,
    transparent: false,
    flatShading: false,
    emissiveMap: texBussard.clone(),
    metalnessMap: texBussard,
    side: THREE.DoubleSide,
    alphaMap: texBussard,
    alphaTest: 0.01,
    metalness: 0.6,
    roughness: 1.0,
  });

  bussardInnerMaterial.push(bussardInnerMaterial_00);
  bussardInnerMaterial.push(bussardInnerMaterial_02);
  bussardInnerMaterial.push(bussardInnerMaterial_03);
  bussardInnerMaterial.push(goldMaterial);
  bussardInnerMaterial.push(chromeMaterial);
  bussardInnerMaterial.push(wireframeMaterial);
  bussardInnerMaterial.push(bussardInnerMaterial_01);


  // Sublight engines
  export const grillMaterial = [];
  const grillMaterial_00 = new THREE.MeshStandardMaterial({
    color: 0xff0000,
    emissive: 0xff0000,
    emissiveIntensity: 4.0,
    opacity: 0.7,
    transparent: true,
    flatShading: false,
    side: THREE.DoubleSide,
    metalness: 0,
    // emissiveMap: texGrill,
    roughness: 1,
    // alphaMap: texGrill,
    // alphaTest: 0.5,
  });
  
  grillMaterial.push(grillMaterial_00);
  grillMaterial.push(grillMaterial_00);
  grillMaterial.push(grillMaterial_00);
  grillMaterial.push(goldMaterial);
  grillMaterial.push(chromeMaterial);
  grillMaterial.push(wireframeMaterial);
  grillMaterial.push(grillMaterial_00);
  
  export const grillInnerMaterial = [];
  const grillInnerMaterial_00 = new THREE.MeshStandardMaterial({
    color: 0x000000,
    emissive: 0xffffff,
    emissiveIntensity: 3.0,
    transparent: true,
    flatShading: false,
    emissiveMap: texGrill.clone(),
    side: THREE.DoubleSide,
    metalness: 0,
    roughness: 1,
  });

  grillInnerMaterial.push(grillInnerMaterial_00);
  grillInnerMaterial.push(grillInnerMaterial_00);
  grillInnerMaterial.push(grillInnerMaterial_00);
  grillInnerMaterial.push(goldMaterial);
  grillInnerMaterial.push(chromeMaterial);
  grillInnerMaterial.push(wireframeMaterial);
  grillInnerMaterial.push(grillInnerMaterial_00);

